
<div class="tooltip-anchor">
    <div class="tooltip-hoverable"><ng-content select="[tooltip-hoverable]"></ng-content></div> 
    <div class="tooltip-content">
        <div class="tooltip-arrow"><img src="assets/icons/solid-arrow.svg"></div> 
        <div class="custom-box tooltip-message">{{tooltipMessage}}</div> 
    </div>
</div>
